<template>
  <DetailTemplate
    :customClass="'property-detail property-property-detail detail-page'"
    v-if="getPermission('property:view')"
  >
    <template v-slot:sidebar-detail>
      <v-card class="h-100" elevation="0">
        <v-chip
          label
          color="chip-custom-blue"
          outlined
          class="text-white p-3 mt-2"
          v-if="payrollArr.barcode"
          style="font-size: 21px !important; font-weight: 700"
          >{{ payrollArr.barcode }}</v-chip
        >
        <span>
          <v-chip
            class="ma-2 custom-status font-weight-500 text-uppercase custom-grey-border"
            text-color="white"
            color="green"
            v-if="payrollArr.status === '166'"
            label
          >
            Processed
          </v-chip>
          <v-chip
            class="ma-2 custom-status font-weight-500 text-uppercase custom-grey-border"
            text-color="white"
            color="warning"
            v-else-if="payrollArr.status === '165'"
            label
          >
            Pending
          </v-chip>
        </span>
        <v-card flat class="custom-grey-border remove-border-radius mb-4 h-100">
          <v-card-title class="headline grey lighten-4 py-1">
            <span
              class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
            >
              Payroll Information</span
            >
          </v-card-title>
          <table class="width-100">
            <tr>
              <th
                valign="middle"
                class="font-size-18 font-weight-500 text-capitalize pb-0"
                width="150px"
              >
                Payroll #
              </th>

              <td class="font-size-18 text-capitalize">
                <v-chip
                  class="font-weight-600 custom-barcode pb-0"
                  color="chip-custom-blue"
                  outlined
                  label
                >
                  {{ payrollArr.barcode }}
                </v-chip>
              </td>
            </tr>
            <tr>
              <th
                valign="middle"
                class="font-size-18 font-weight-500 text-capitalize pt-0 pb-0"
                width="150px"
              >
                Cleaner #
              </th>
              <td
                valign="middle"
                class="font-size-18 text-capitalize pt-0 pb-0"
              >
                <div v-if="payrollArr?.cleaner?.barcode">
                  <v-chip
                    v-on:click="routeToCleaner(payrollArr.cleaner_id)"
                    class="font-weight-600 custom-barcode"
                    color="chip-custom-blue"
                    outlined
                    label
                  >
                    {{ payrollArr?.cleaner?.barcode }}
                  </v-chip>
                </div>
                <em v-else class="text-muted"> No cleaner </em>
              </td>
            </tr>
            <tr>
              <th
                valign="middle"
                class="font-size-18 font-weight-500 text-capitalize pt-0"
              >
                Cleaner Name
              </th>
              <td valign="middle" class="font-size-18 text-capitalize pt-1">
                <template v-if="payrollArr?.cleaner?.display_name">
                  {{ payrollArr?.cleaner?.display_name }}
                </template>
                <em v-else class="text-muted"> no cleaner name</em>
              </td>
            </tr>
            <tr>
              <th
                class="font-size-18 font-weight-500 text-capitalize pt-1"
                width="150px"
              >
                Date Range
              </th>
              <td class="font-size-18 text-capitalize pt-1">
                {{ formatDate(payrollArr?.payroll_start_date) }} - {{
                  formatDate(payrollArr?.payroll_end_date) }}
              </td>
            </tr>
            <tr>
              <th class="font-size-18 font-weight-500 text-capitalize pt-1">
                No. of Jobs
              </th>
              <td class="font-size-18 text-capitalize pt-1">
                <template v-if="payrollArr.total_jobs">
                  {{ payrollArr?.total_jobs }}
                </template>
                <em v-else class="text-muted">No jobs</em>
              </td>
            </tr>
            <tr>
              <th class="font-size-18 font-weight-500 text-capitalize pt-1">
                Extra Jobs
              </th>
              <td class="font-size-18 text-capitalize pt-1">
                <template v-if="payrollArr.total_jobs">
                  <div v-if="payrollArr?.total_jobs > 40">
                    {{ payrollArr.total_jobs - 40 }}
                  </div>
                  <div v-else>0</div>
                </template>
              </td>
            </tr>
            <tr>
              <th class="font-size-18 font-weight-500 text-capitalize pt-1">
                Total Hours
              </th>
              <td class="font-size-18 text-capitalize pt-1">
                <template v-if="payrollArr.total_hours">
                  {{ payrollArr?.total_hours }}
                </template>
                <em v-else class="text-muted"> No hours</em>
              </td>
            </tr>
            <tr>
              <th class="font-size-18 font-weight-500 text-capitalize">
                Extra Hours
              </th>
              <td class="font-size-18 text-capitalize">
                <template v-if="payrollArr.total_hours > 0">
                  <div v-if="payrollArr.total_hours > 176">
                    {{ payrollArr.total_hours - 176 }}
                  </div>
                  <em v-else class="text-muted">
                    No hours</em>
                </template>
                <em v-else class="text-muted">
                  No hours</em>

              </td>
            </tr>
            <tr>
              <th class="font-size-18 font-weight-500 text-capitalize">
                Skip Hours
              </th>
              <td class="font-size-18 text-capitalize">
                <template v-if="payrollArr.skip_hours > 0">
                  <div v-if="payrollArr.skip_hours > 0">
                    {{ payrollArr.skip_hours }}
                  </div>
                  <em v-else class="text-muted">
                    No skipped hours</em>
                </template>
                <em v-else class="text-muted">
                  No skipped hours</em>
              </td>
            </tr>
          </table>
        </v-card>
      </v-card>
    </template>
    <template v-slot:header-title>
      <div v-if="pageLoading">
        <v-skeleton-loader
          class="custom-skeleton"
          width="400"
          height="28"
          type="text"
        >
        </v-skeleton-loader>
      </div>

      <div class="d-flex" v-else>
        <h1 class="form-title custom-nowrap-ellipsis text-capitalize mr-2 mt-3">
          {{ getPageTitle }}
        </h1>
      </div>
    </template>
    <template v-slot:header-action>
      <v-skeleton-loader
        class="custom-skeleton d-inline-block mr-2"
        v-if="pageLoading"
        type="button"
        height="28"
      >
      </v-skeleton-loader>
      <template v-if="getPermission('property:update')">
        <v-skeleton-loader
          class="custom-skeleton d-inline-block mr-2"
          v-if="pageLoading"
          type="button"
          height="28"
        >
        </v-skeleton-loader>
        <v-btn
          depressed
          v-else
          class="mx-2 custom-bold-button white--text"
          color="cyan"
          v-on:click="editPayroll()"
        >
          <v-icon small left>mdi-pencil</v-icon>
          Edit
        </v-btn>
      </template>
      <v-menu
        transition="slide-y-transition"
        bottom
        offset-y
        :nudge-left="20"
        content-class="custom-menu-list"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :disabled="!formValid || formLoading || pageLoading"
            :loading="formLoading"
            class="mx-2 custom-bold-button white--text"
            color="cyan"
            v-bind="attrs"
            v-on="on"
          >
            More... <v-icon right>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <template v-for="(more, index) in moreActions">
            <v-list-item
              link
              v-on:click="updateMoreAction(more.action)"
              :key="index"
              :disabled="more.disabled"
            >
              <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                <v-icon class="icon-default-blue">{{ more.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-400 font-size-12">{{
                more.title
              }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
      <v-btn
        depressed
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="goBack"
      >
        <v-icon small left>mdi-keyboard-backspace</v-icon>
        Back
      </v-btn>
    </template>
    <template v-slot:body>
      <v-tabs
        v-model="propertyTab"
        background-color="transparent"
        color="cyan"
        class="custom-tab-transparent"
      >
        <template v-for="(tab, index) in tabs">
          <v-tab
            class="font-size-16 font-weight-600 px-8"
            :key="index"
            :href="'#' + tab.key"
            :disabled="tab.disabled"
          >
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <!-- <inline-svg
                :src="$assetURL('media/custom-svg/' + tab.key + '.svg')"
              /> -->
              <v-icon v-if="tab.icon" class="mr-2" size="20">
                {{ tab.icon }}
              </v-icon>
              <!--end::Svg Icon-->
            </span>
            {{ tab.title }}
          </v-tab>
        </template>
      </v-tabs>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll newscroll"
        style="height: calc(100vh - 150px)"
      >
        <v-tabs-items v-model="propertyTab">
          <v-tab-item v-if="getPermission('property:view')" :value="'payroll'">
            <v-row class="white-background">
              <v-col cols="6">
                <v-skeleton-loader
                  class="custom-skeleton height-30px"
                  v-if="pageLoading"
                  type="text@11"
                >
                </v-skeleton-loader>
                <template v-else>
                  <v-card
                    flat
                    class="custom-grey-border remove-border-radius mb-4 h-100"
                  >
                    <v-card-title class="headline grey lighten-4 py-1">
                      <span
                        class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
                      >
                        Salary Details
                      </span>
                    </v-card-title>
                    <table v-if="payrollArr" width="100%">
                      <tr>
                        <th
                          valign="middle"
                          class="font-size-18 font-weight-500 text-capitalize"
                          width="150px"
                        >
                          Salary Type
                        </th>
                        <td
                          valign="middle"
                          class="font-size-18 text-capitalize"
                        >
                          <div v-if="payrollArr?.salary_type">
                            {{ payrollArr?.salary_type }}
                          </div>

                          <em v-else class="text-muted"> No salary type </em>
                        </td>
                      </tr>
                      <tr>
                        <th
                          valign="middle"
                          class="font-size-18 font-weight-500 text-capitalize"
                        >
                          Basic
                        </th>
                        <td
                          valign="middle"
                          class="font-size-18 text-capitalize"
                        >
                          <template v-if="payrollArr.basic">
                            $ {{ payrollArr.basic }}
                          </template>
                          <em v-else class="text-muted"> No basic</em>
                        </td>
                      </tr>
                      <tr>
                        <th
                          valign="middle"
                          class="font-size-18 font-weight-500 text-capitalize"
                        >
                          Housing allowance
                        </th>
                        <td
                          valign="middle"
                          class="font-size-18 text-capitalize"
                        >
                          <template v-if="payrollArr?.housing_allowance">
                            $ {{ payrollArr?.housing_allowance }}
                          </template>
                          <em v-else class="text-muted">
                            No housing allowance</em
                          >
                        </td>
                      </tr>
                      <tr>
                        <th
                          valign="middle"
                          class="font-size-18 font-weight-500 text-capitalize"
                        >
                          Transport allowance
                        </th>
                        <td valign="middle" class="font-size-18 text-lowercase">
                          <template v-if="payrollArr?.transport_allowance">
                            $ {{ payrollArr?.transport_allowance }}
                          </template>
                          <em v-else class="text-muted ml-2">
                            No transport allowance</em
                          >
                        </td>
                      </tr>
                      <tr>
                        <th
                          valign="middle"
                          class="font-size-18 font-weight-500 text-capitalize"
                        >
                          Phone allowance
                        </th>
                        <td
                          valign="middle"
                          class="font-size-18 text-capitalize"
                        >
                          <template v-if="payrollArr?.phone_allowance">
                            $ {{ payrollArr?.phone_allowance }}
                          </template>
                          <em v-else class="text-muted ml-2">
                            No phone allowance</em
                          >
                        </td>
                      </tr>
                      <tr>
                        <th
                          valign="middle"
                          class="font-size-18 font-weight-500 text-capitalize"
                        >
                          OT pay
                        </th>
                        <td
                          valign="middle"
                          class="font-size-18 text-capitalize"
                        >
                          <template v-if="payrollArr?.overtime_pay">
                            $ {{ payrollArr?.overtime_pay }}
                          </template>
                          <em v-else class="text-muted ml-2"> No ot pay</em>
                        </td>
                      </tr>
                      <tr>
                        <th
                          valign="middle"
                          class="font-size-18 font-weight-500 text-capitalize"
                        >
                          Incentives
                        </th>
                        <td
                          valign="middle"
                          class="font-size-18 text-capitalize"
                        >
                          <template v-if="payrollArr?.job_incentives">
                            $ {{ payrollArr.job_incentives }}
                          </template>
                          <em v-else class="text-muted ml-2"> No incentives</em>
                        </td>
                      </tr>
                    </table>
                  </v-card>
                </template>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item v-if="getPermission('history:view')" :value="'history'">
            <InternalHistoryDetail
              type="payroll"
              :type_id="payrollArr?.id"
            ></InternalHistoryDetail>
          </v-tab-item>
        </v-tabs-items>
      </perfect-scrollbar>
    </template>
  </DetailTemplate>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
// import PropertyMixin from "@/core/plugins/property-mixin";
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import InternalHistoryDetail from "@/view/pages/partials/Detail/Internal-History-Detail.vue";
import { GET, PATCH } from "@/core/services/store/request.module";
import moment from "moment";
// import Status from "@/view/pages/partials/Status.vue";

export default {
  mixins: [CommonMixin, ValidationMixin],
  name: "property-detail",
  title: "Site Location",
  data() {
    return {
      propertyTab: "property",
      cleaner: null,
      payroll: null,
      customer: 0,
      //propertyTab: null,
      pageLoading: true,
      historyLoading: true,
      deleteDialog: false,
      payrollArr: {},
      history: [],
      moreActions: [],
      // category: {
      //   property_id: 0,
      //   customer_id: 0,
      //   categoryList: [
      //     {
      //       name: null,
      //       subcategory: [
      //         {
      //           name: null,
      //         },
      //       ],
      //     },
      //   ],
      // },

      tabs: [
        {
          title: "Overview",
          icon: "mdi-ticket",
          key: "payroll",
          disabled: false,
        },
        {
          title: "History",
          icon: "mdi-account-multiple",
          key: "history",
          disabled: false,
        },
      ],
      createTransactions: [
        {
          title: "Visit",
          action: "job",
        },
        /*{
          title: "Quotation",
          action: "quotation"
        },*/
        /* {
          title: "Invoice",
          action: "invoice",
        }, */
      ],
    };
  },
  components: {
    // Status,
    DetailTemplate,
    InternalHistoryDetail,
  },
  methods: {
    formatDateStartTime() {
      return moment().format("hh:mm A");
    },
    updateMoreAction(action) {
      const _this = this;
      this.statusValue = action;
      switch (action) {
        case "mark_as_pending":
          _this.patchPayroll(action);
          break;
        case "mark_as_processed":
          _this.patchPayroll(action);
          break;
        case "send_payslip_to_cleaner":
          // _this.patchPayroll(1, action);
          break;
        case "download_payslip":
          // _this.patchPayroll(1, action);
          break;
      }
    },
    patchPayroll(action = "") {
      const _this = this;
      // _this.statusVal = status;
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "payroll/status",
          data: {
            payroll: [_this.payroll],
            action,
            remark: null,
          },
        })
        .then(() => {
          _this.getPayroll().then((response) => {
            _this.payrollArr = response;
            _this.moreActions = response.more_actions;
          });
          _this.pageLoading = false;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    editPayroll() {
      this.$router.push(
        this.getDefaultRoute("payroll.update", {
          query: { cleaner: this.payrollArr.cleaner_id },
          params: { engineer: this.payroll },
        })
      );
    },
    // getHistories() {
    //   const _this = this;
    //   _this.$store
    //     .dispatch(GET, { url: `property/${_this.payroll}/history` })
    //     .then(({ data }) => {
    //       _this.history = data;
    //     })
    //     .catch((error) => {
    //       _this.logError(error);
    //     })
    //     .finally(() => {
    //       _this.historyLoading = false;
    //     });
    // },
    routeToCleaner(id) {
      this.$router.push({
        name: "admin.engineer.detail",
        params: { id },
      });
    },
    getPayroll() {
      const _this = this;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(GET, { url: "payroll/" + _this.payroll })
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  mounted() {
    const _this = this;
    _this
      .getPayroll()
      .then((response) => {
        _this.payrollArr = response;
        _this.moreActions = response.more_actions;
        _this.$store.dispatch(SET_BREADCRUMB, [
          { title: "Payroll", route: "payroll" },
          { title: "Detail" },
          { title: response.barcode },
        ]);
      })
      .catch((error) => {
        _this.logError(error);
        _this.$router.go(-1);
      })
      .finally(() => {
        _this.pageLoading = false;
      });
  },
  created() {
    const _this = this;
    _this.payroll = _this.$route.params.id;
    if (!_this.payroll || _this.payroll <= 0) {
      _this.$router.go(-1);
    }

    if (_this.$route.query && _this.$route.query.tab) {
      _this.propertyTab = _this.$route.query.tab;
    }
  },
  computed: {
    getPageTitle() {
      let result = [];
      if (this.payrollArr && this.payrollArr.customer) {
        result.push(this.payrollArr.customer.display_name);
      }
      /*if(this.payrollArr && this.payrollArr.customer && this.payrollArr.customer.default_person){
        result.push(this.payrollArr.customer.default_person.display_name);
      }*/
      /* if (this.payrollArr && this.payrollArr.barcode) {
        result.push(this.payrollArr.barcode);
      } */
      return result.join(" • ");
    },

    // getStatus() {
    //   if (this.payrollArr.status === '166') {
    //     return 'Processed'
    //   }
    //   else {
    //     return 'Pending'
    //   }
    // },
    getBarcode() {
      return this.lodash.isEmpty(this.payrollArr) === false
        ? this.payrollArr.barcode
        : false;
    },
  },
};
</script>
